import { IContactInformation } from 'types/apiTypes';
import Table from './Table';
import SkeletonLoader from './SkeletonLoader';
import React from 'react';
import classNames from 'classnames';

interface ContactInformationProps {
  loading: boolean;
  title: string;
  contactInformation: IContactInformation | undefined;
}
const ContactInformation = ({ loading, title, contactInformation }: ContactInformationProps) => {
  return (
    <div className="w-full pb-8 pr-5 xl:w-1/2">
      <Table className="w-full">
        <thead>
          <Table.Tr>
            <Table.Th colSpan={3}>{title}</Table.Th>
          </Table.Tr>
        </thead>
        <tbody>
          <Table.Tr>
            <Table.Td className="font-semibold">contact</Table.Td>
            <Table.Td>
              <SkeletonLoader loading={loading}>
                {contactInformation?.contact === '' ? '-' : (contactInformation?.contact ?? '-')}
              </SkeletonLoader>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td className="font-semibold">email</Table.Td>
            <Table.Td>
              <SkeletonLoader loading={loading}>
                {contactInformation?.email === '' ? '-' : (contactInformation?.email ?? '-')}
              </SkeletonLoader>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td className="font-semibold">telWorkingTime</Table.Td>
            <Table.Td>
              <SkeletonLoader loading={loading}>
                {contactInformation?.telWorkingTime === ''
                  ? '-'
                  : (contactInformation?.telWorkingTime ?? '-')}
              </SkeletonLoader>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td className="font-semibold">telOutsideWorkingTime</Table.Td>
            <Table.Td>
              <SkeletonLoader loading={loading}>
                {contactInformation?.telOutsideWorkingTime === ''
                  ? '-'
                  : (contactInformation?.telOutsideWorkingTime ?? '-')}
              </SkeletonLoader>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td className="font-semibold">mobile</Table.Td>
            <Table.Td>
              <SkeletonLoader loading={loading}>
                {contactInformation?.mobile === '' ? '-' : (contactInformation?.mobile ?? '-')}
              </SkeletonLoader>
            </Table.Td>
          </Table.Tr>
          {(contactInformation?.workingTimes.length ?? 0) > 0 && (
            <>
              <Table.Tr>
                <Table.Th colSpan={3}>Working time</Table.Th>
              </Table.Tr>
              {contactInformation?.workingTimes.map((wt, index) => {
                return (
                  <React.Fragment key={index}>
                    <Table.Tr>
                      <Table.Td>
                        <span className="font-semibold">startTime: </span>
                        {wt.startTime === '' ? '-' : (wt.startTime ?? '-')}
                      </Table.Td>

                      <Table.Td>
                        <span className="font-semibold">endTime: </span>
                        {wt.endTime === '' ? '-' : (wt.endTime ?? '-')}
                      </Table.Td>
                    </Table.Tr>
                    <Table.Tr
                      className={classNames(
                        contactInformation?.workingTimes.length > 1 &&
                          'border-b border-b-neutral-400'
                      )}
                    >
                      <Table.Td>
                        <span className="font-semibold">timeZone: </span>
                        {wt.timeZone === '' ? '-' : (wt.timeZone ?? '-')}
                      </Table.Td>

                      <Table.Td>
                        <span className="font-semibold">weekdays: </span>
                        {wt.weekdays === '' ? '-' : (wt.weekdays ?? '-')}
                      </Table.Td>
                    </Table.Tr>
                  </React.Fragment>
                );
              })}
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ContactInformation;
